import "./styles/not-found.scss";
import Logo from "./images/wings_only.png";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <main className="not-found-page">
      <img src={Logo} alt="PMW wings logo" className="wings-logo" />
      <h2>
        Sorry, this page does not exist -{" "}
        <span onClick={() => navigate("/home")}>Head Home</span>
      </h2>
    </main>
  );
}
